import { type ButtonHTMLAttributes, type ReactNode } from 'react'
import styles from './IconButton.module.css'

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean
  iconSize?: 'default' | 'play'
  icon: ReactNode
  label: string
  loading?: boolean
  size?: 'sm' | 'md'
  tone?: 'neutral' | 'danger'
  variant?: 'default' | 'danger' | 'ghost'
}

export const IconButton = ({
  active = false,
  children,
  className,
  iconSize = 'default',
  icon,
  label,
  loading = false,
  size = 'md',
  tone,
  type = 'button',
  variant = tone === 'danger' ? 'danger' : 'default',
  ...props
}: IconButtonProps) => (
  <button
    aria-label={label}
    className={[
      styles.button,
      styles[size],
      styles[variant],
      styles[`icon-${iconSize}`],
      active ? styles.active : '',
      loading ? styles.loading : '',
      className
    ].filter(Boolean).join(' ')}
    title={props.title ?? label}
    type={type}
    {...props}
  >
    {icon}
    {children}
  </button>
)
